import { render, staticRenderFns } from "./TheSpaceSettings.vue?vue&type=template&id=05a7a476&"
import script from "./TheSpaceSettings.vue?vue&type=script&lang=js&"
export * from "./TheSpaceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports